module.exports = __webpack_public_path__ + "img/qiu360wei.41bbb1b5.png";